let months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const monthsFormatted = months.map((month, index) => {
  return {key: month, text: month, value: index};
});

export default monthsFormatted;
